var exports = {
  "kL": "xb99ab02a--49246b--container",
  "nf": "xb99ab02a--49246b--link",
  "$d": "xb99ab02a--49246b--link-area",
};

module.exports = exports;
